"use client";

import { useEffect } from "react";
import { useLanguageContext } from "./LanguageContext";

/**
 * Syncs the <html lang> attribute with the current language.
 * Must be rendered inside LanguageProvider.
 */
export function HtmlLangUpdater() {
  const { language } = useLanguageContext();

  useEffect(() => {
    document.documentElement.lang = language;
  }, [language]);

  return null;
}
